ShareImageGen = function(dispatcher) {
	///This.type === 0 means 360 image and this.type === 1 means twitter image
	//LISTENS TO EVENTS.SHARE_IMAGE TO GENERATE IMAGE EXPECTS MESSAGE AND TYPE
	//    var data = {
	//    	message : "Lorem ipsum dolor",
	//    	type : 0 //0 FACEBOOK 1 TWITTER   
	//		};
	///DISPATCHES EVENTS.SHARE_IMAGE_READY WITH BASE64 IMAGE

	/*---------------------------------------------------
		STATIC
	-----------------------------------------------------*/
	this.FB_WIDTH_IMG = 6000;
	this.FB_HEIGHT_IMG = 1781;
	this.FB_WIDTH = 2000; //mask width
	this.FB_HEIGHT = 1781;
	this.TW_WIDTH = 1000;
	this.TW_HEIGHT = 1000;
	this.FONT_FB = 'bold 150px Roboto Condensed';
	this.FONT_TW = 'bold 85px Roboto Condensed';

	this.FB_BK = (app.filmReleased  === false) ?  "media/img/imageGen/nebula_fb360.jpg" : "media/img/imageGen/nebula_fb360_released.jpg";
	this.FB_BK2 = "media/img/imageGen/nebula_mask_fb360.jpg";
	this.FB_MASK = "media/img/imageGen/nebula_noise_fb360.jpg"; //text mask
	this.FB_TT = (app.filmReleased === false) ? "media/img/imageGen/TT_centre_fb360.png" : "media/img/imageGen/TT_centre_fb360_released.png";

	this.TW_BK = (app.filmReleased   === false) ? "media/img/imageGen/nebula_tw3.jpg" : "media/img/imageGen/nebula_tw3_released.jpg";
	this.TW_MASK = "media/img/imageGen/nebula_noise_tw3.jpg";
	this.TW_TT =  "media/img/imageGen/TT_centre_tw.png";
	
	this.JPG_QUALITY = 0.8;

	this.XMP_IMAGE = {
		url : "media/xmp/xmpData.jpg",
		marker : "",
		reader : "",
		ready : false,
		snapshot :""
	};

	/*-----------------------------------------------
		VARIABLES
	--------------------------------------------------*/

	this.fbResource = false;
	this.twResource = false;
	this.dispatcher = dispatcher;
	this.loadedEvent = this.onAssetReady.bindX(this);
	this.init();
};

ShareImageGen.prototype = {
	
	constructor: ShareImageGen,

	/*---------------------------------------------------
	INITIALIZER
	--------------------------------------------------*/

	init : function(){
		this.createResourceList();
		this.initCanvas();
		this.bindXEvents();
	},
	
	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/

	//CREATE IMAGE SIZE LIST,BITMAPS TO LOAD AND SETS FONT SIZES FOR TW AND FB
	createResourceList : function(){
		this.resources = [ [ this.FB_BK, this.FB_MASK,this.FB_BK2,this.FB_TT, ] , [ this.TW_BK, this.TW_MASK] ];
		this.sizes = [ [ this.FB_WIDTH, this.FB_HEIGHT ], [ this.TW_WIDTH, this.TW_HEIGHT ] ];
		this.loadedResources = [ false, false ];
		this.fonts = [ this.FONT_FB ,this.FONT_TW ];
	},

	bindXEvents : function() {
		this.dispatcher.addEventListener( EVENTS.SHARE_IMAGE, this.onImageShare.bindX( this ) );
	},

	initCanvas : function() {
		//PIXI CANVAS FOR TEXT MASK

		this.renderer = PIXI.autoDetectRenderer( 800,800, {preserveDrawingBuffer : true, antialias: true  } );
		this.stage = new PIXI.Container();

		//CANVAS TO COMBINE BACKGROUND AND TEXT MASK IMAGE
		this.canvas = document.createElement( 'canvas' );
		this.canvas.id     = "backgroundSnap";
		this.canvas.width  =  800;
		this.canvas.height =  800;
		this.ctx = this.canvas.getContext( "2d" );

		//LOADER TO LOAD IMAGES
		this.loader = new PIXI.loaders.Loader();
		
	},

	//LISTENER TRIGGERS WHEN IMAGE IS SHARED
	onImageShare : function ( event,data ){

		this.type = data.type;
		if(this.type === 0){
			this.JPG_QUALITY = 1;
		}
		this.message = data.message;

		this.resizeCanvases();

		if( this.checkAssets() ){
			this.generateImage();
		}else{
			this.loadAssets();
		}

	},

	resizeCanvases : function() {
		this.renderer.resize( this.sizes[ this.type ][ 0 ], this.sizes[ this.type ][ 1 ] );
		
		this.canvas.width  =  this.sizes[ this.type ][ 0 ];
		this.canvas.height =  this.sizes[ this.type ][ 1 ];
		this.ctx.canvas.width  = this.sizes[ this.type ][ 0 ];
		this.ctx.canvas.height = this.sizes[ this.type ][ 1 ];

		if(this.type === 0){
			this.canvas.width  =  this.FB_WIDTH_IMG;
			this.canvas.height =  this.FB_HEIGHT_IMG;
			this.ctx.canvas.width  = this.FB_WIDTH_IMG;
			this.ctx.canvas.height = this.FB_HEIGHT_IMG;
		}
	},



	checkAssets : function() {
		return this.loadedResources[ this.type ];
	},

	loadAssets : function() {
		this.loader.add( this.resources[ this.type ] );
		if(!this.fontReady) this.loader.add('desyrel', 'style/fonts/font2.xml');
		this.loader.off( "complete" , this.loadedEvent );
		this.loader.on( "complete" , this.loadedEvent );
		this.loader.load();
	},

	onAssetReady : function() {
		this.fontReady = true;
		console.log("assets ready generate image ");
		this.setResourcesReady();
		this.generateImage();
	},

	setResourcesReady : function() {
		this.loadedResources[ this.type ] = true;
	},


	removeSprites : function() {
		this.ctx.clearRect( 0, 0, this.canvas.width, this.canvas.height );
		if( this.text ) this.stage.removeChild( this.text );
		if( this.mask ) this.stage.removeChild( this.mask );
		if( this.maskBKSprite ) this.stage.removeChild( this.maskBKSprite );
		if( this.tt ) this.stage.removeChild( this.tt );
	},

	generateImage : function() {
		console.log("pixi creating image ");
		this.formatMessage();
		this.removeSprites();
		this.createTextMask();
	},
	
	formatMessage : function(){
		this.lines = MessageHelper.getLines( this.message, 25 );
		this.message = MessageHelper.getMessageFormat( this.lines );
	},

	createTextMask : function() {
		var maskBKSprite = "";
		var TTSPRITE = "";
		if(this.type === 0){
			maskBKSprite = this.loader.resources[ this.resources[ this.type ][ 2 ] ].texture;
			TTSPRITE =  this.loader.resources[ this.resources[ this.type ][ 3 ] ].texture;
		}else{
			maskBKSprite = this.loader.resources[ this.resources[ this.type ][ 0 ] ].texture;
		//	TTSPRITE =  this.loader.resources[ this.resources[ this.type ][ 2 ] ].texture;
		}
		this.maskBK =  new PIXI.Sprite( maskBKSprite );
		this.stage.addChild( this.maskBK );

		var maskSprite = this.loader.resources[ this.resources[ this.type ][ 1 ] ].texture;
		this.mask =  new PIXI.Sprite( maskSprite );
		this.stage.addChild( this.mask );


		//this.text =new PIXI.extras.BitmapText(this.message, { font: '50px Desyrel', align: 'center' });
 		this.text = new PIXI.Text(this.message, { font : this.fonts[this.type], fill : 'white', align : 'center' });

		this.text.position.x = this.sizes[ this.type ][ 0 ] / 2 - this.text.width / 2 ;
		this.text.position.y =  this.sizes[ this.type ][ 1 ] / 2 - (this.text.height / 2)  - 100;
		this.stage.addChild( this.text);
		
		this.tt =  new PIXI.Sprite( TTSPRITE );
	
		this.tt.position.x = this.sizes[ this.type ][ 0 ] / 2 - this.tt.width / 2 ;
		if(this.type === 0){
			this.tt.position.y =  this.sizes[ this.type ][ 1 ] - this.tt.height - 180 ;
			this.stage.addChild( this.tt );
		}
		else{
			this.tt.position.y =  this.sizes[ this.type ][ 1 ] - this.tt.height - 50 ;
			this.text.position.y =  this.sizes[ this.type ][ 1 ] / 2 - (this.text.height / 2)  - 50;
		}
		

//asdfdsaf
		this.mask.mask = this.text;

		this.renderer.render( this.stage );

		this.timeOutDel = setTimeout( this.snapMaskImage.bindX(this), 300 );

	},

	snapMaskImage : function(){
		clearTimeout(this.timeOutDel);
		console.log("snapshot  image ");
		var sourceCanvas = this.renderer.extract.canvas();
		var sourceContext = sourceCanvas.getContext( '2d' );
		this.dataMaskUrl = sourceContext.canvas.toDataURL( 'image/jpeg' , this.JPG_QUALITY );
		if(this.type === 1){
				var data = {};
				data.type =1;
				data.img = this.dataMaskUrl;
				this.dispatcher.dispatch(EVENTS.SHARE_IMAGE_READY,data);
		}else{
			var maskedImg = new Image();
			maskedImg.onload = function () {
			
				this.ctx.drawImage(this.loader.resources[ this.resources[ this.type ][ 0 ] ].data,0,0 );
				this.ctx.drawImage(maskedImg,this.sizes[ this.type ][ 0 ],0 );
	
				this.dataUrl  = this.ctx.canvas.toDataURL( 'image/jpeg' , this.JPG_QUALITY ); 
				this.timeOutDel = setTimeout( this.loadXMPData.bindX(this), 100 );
				
			}.bindX(this);
			maskedImg.src = this.dataMaskUrl;
		}
	

	},

	loadXMPData : function(){
		clearTimeout(this.timeOutDel);
		console.log("load  xmp");
		var xhr = new XMLHttpRequest();

		xhr.open("GET", this.XMP_IMAGE.url );
		xhr.responseType = "blob";
		
		xhr.onload = function( e ){
			this.XMP_IMAGE.reader = new FileReader();

			this.XMP_IMAGE.reader.onload = function( event ) {
				this.XMP_IMAGE.marker = metadata.parse( this.XMP_IMAGE.reader.result );
				this.XMP_IMAGE.ready = true;
				this.timeOutDel = setTimeout( this.injectXMP.bindX(this), 100 );
				
			}.bindX( this );

			this.XMP_IMAGE.reader.readAsArrayBuffer( e.target.response );
		}.bindX( this );

		xhr.send();
	
	},
	
	injectXMP : function(){
		clearTimeout(this.timeOutDel);
		console.log("with delaysss injecting  xmp");
		var ab = this.dataURIToArrayBuffer(this.dataUrl);
		//copy sample metaData to snapshot booom!!!!!
		this.blob360 = metadata.copy(this.XMP_IMAGE.reader.result, ab, this.XMP_IMAGE.marker);
		console.log("creating  blob");
		var data = {};
		data.type = 0;
		data.img = this.blob360;
		this.dispatcher.dispatch( EVENTS.SHARE_IMAGE_READY_FB, data);
		//this.genImageB64();
		
	},

	dataURIToArrayBuffer : function ( dataURI ) {
		var byteString;
		if ( dataURI.split(',')[ 0 ].indexOf( 'base64' ) >= 0 )
			byteString = atob(dataURI.split( ',' )[ 1 ] );
		else
			byteString = unescape( dataURI.split( ',' )[ 1 ] );
		
		// separate out the mime component
		var mimeString = dataURI.split( ',' )[ 0 ].split( ':' )[ 1 ].split( ';' )[ 0 ];
		
		// write the bytes of the string to an ArrayBuffer
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[ i ] = byteString.charCodeAt( i );
		}
		
		return ab;
	},

	genImageB64 : function(){
		var reader = new FileReader();
		reader.onload = function(){
			this.XMP_IMAGE.snapshot = reader.result;
			this.dispatcher.dispatch( EVENTS.SHARE_IMAGE_READY, this.XMP_IMAGE.snapshot );
		}.bindX( this );
		reader.readAsDataURL( this.blob360 );
	}

};



